export default {"src":"/_next/static/media/Ribbon1.e589506c.svg","height":100,"width":407};